import { useEffect, useMemo } from 'react'
import NoSleep from 'nosleep.js'

export const useNoSleep = () => {
  const noSleep = useMemo(() => new NoSleep(), [])

  return noSleep
}

export const useNoSleepNow = () => {
  const noSleep = useNoSleep()
  useEffect(() => {
    noSleep.enable().catch(() => {}) // silently catching NotAllowedError when page not visible
    return () => {
      noSleep.disable()
    }
  }, [])
}